module.exports = __webpack_public_path__ + "img/Kerze_Blau.5cbca385.png";